<template>
  <div class="hello">
      <h1>{{ msg }}</h1>
      <p>Thanks for trying out Normcore while we’re in beta! Use this Dashboard to manage applications and download the latest version of the SDK. We’re working on improving it as much as we can, so if you have any questions or feedback, <a href="https://discord.gg/XvMthZG">hop over to our Discord</a> and let us know!</p>
  </div>
</template>

<script>
export default {
  name: "Welcome",
  props: {
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  // color: #42b983;
}
.hello {
  width: 70%;
  text-align: left;
  // margin: auto;
  line-height: 1.3;
}





</style>
